import { InputWithLabel } from '@adotel/components'
import Typography from '@material-ui/core/Typography'

import { getTranslate } from '../../../../localization'
import { SessionConfiguration } from '../../../../types/iamSessions'
import useStyles from './index.styles'

type Props = {
  updateSessionConfigInput: SessionConfiguration
  setUpdateSessionConfigInput: React.Dispatch<
    React.SetStateAction<SessionConfiguration>
  >
}
const SessionConfigurationPart = ({
  updateSessionConfigInput,
  setUpdateSessionConfigInput
}: Props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.header}>
        {getTranslate('Session Configuration')}
      </Typography>
      <Typography variant="h5" className={classes.subTitle}>
        {getTranslate('Configure session limits and timeouts')}
      </Typography>
      <div className={classes.main}>
        <InputWithLabel
          label={getTranslate('Maximum Sessions Per User')}
          helpertext={getTranslate(
            'Number of concurrent sessions allowed per user'
          )}
          value={updateSessionConfigInput.maxSessionsPerUser}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setUpdateSessionConfigInput({
              ...updateSessionConfigInput,
              maxSessionsPerUser: Number(value)
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
        <InputWithLabel
          label={getTranslate('Idle Session Timeout (Minutes)')}
          helpertext={getTranslate(
            'Session will be terminated after this period of inactivity'
          )}
          value={updateSessionConfigInput.sessionIdleTimeoutMinutes}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setUpdateSessionConfigInput({
              ...updateSessionConfigInput,
              sessionIdleTimeoutMinutes: Number(value)
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
        <InputWithLabel
          label={getTranslate('Absolute Session Timeout (Minutes)')}
          helpertext={getTranslate(
            'Maximum session duration regardless of activity (must be ≥ idle timeout)'
          )}
          value={updateSessionConfigInput.sessionAbsoluteTimeoutMinutes}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setUpdateSessionConfigInput({
              ...updateSessionConfigInput,
              sessionAbsoluteTimeoutMinutes: Number(value)
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
        <InputWithLabel
          label={getTranslate('Access token expiry (Minutes)')}
          helpertext={getTranslate(
            'Access token will expire after this duration. A new access token must be obtained using the refresh token.'
          )}
          value={updateSessionConfigInput.accessTokenExpiryMinutes}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setUpdateSessionConfigInput({
              ...updateSessionConfigInput,
              accessTokenExpiryMinutes: Number(value)
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
        <InputWithLabel
          label={getTranslate('Refresh token expiry (Minutes)')}
          helpertext={getTranslate(
            'Refresh token will expire after this duration. User must log in again after expiry'
          )}
          value={updateSessionConfigInput.refreshTokenExpiryMinutes}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setUpdateSessionConfigInput({
              ...updateSessionConfigInput,
              refreshTokenExpiryMinutes: Number(value)
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
        <InputWithLabel
          label={getTranslate('Web token expiry (Minutes)')}
          helpertext={getTranslate('Web token will expire after this duration')}
          value={updateSessionConfigInput.webAccessTokenExpiryMinutes}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setUpdateSessionConfigInput({
              ...updateSessionConfigInput,
              webAccessTokenExpiryMinutes: Number(value)
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
        <InputWithLabel
          label={getTranslate('OTP TTL (Second)')}
          // helpertext={getTranslate('Web token will expire after this duration')}
          value={updateSessionConfigInput.otpTTLSeconds}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setUpdateSessionConfigInput({
              ...updateSessionConfigInput,
              otpTTLSeconds: Number(value)
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
        <InputWithLabel
          label={getTranslate('OTP CoolDown (Second)')}
          // helpertext={getTranslate('Web token will expire after this duration')}
          value={updateSessionConfigInput.otpCoolDownSeconds}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setUpdateSessionConfigInput({
              ...updateSessionConfigInput,
              otpCoolDownSeconds: Number(value)
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
        <InputWithLabel
          label={getTranslate('OTP max resend attempts (Second)')}
          // helpertext={getTranslate('Web token will expire after this duration')}
          value={updateSessionConfigInput.otpMaxResendSeconds}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setUpdateSessionConfigInput({
              ...updateSessionConfigInput,
              otpMaxResendSeconds: Number(value)
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
        <InputWithLabel
          label={getTranslate('Pending 2FA session (Second)')}
          // helpertext={getTranslate('Web token will expire after this duration')}
          value={updateSessionConfigInput.pending2FASessionSecond}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setUpdateSessionConfigInput({
              ...updateSessionConfigInput,
              pending2FASessionSecond: Number(value)
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
      </div>
    </div>
  )
}

export default SessionConfigurationPart
